// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-popover-overlay .home-ant-popover-inner {\n  padding: 0;\n  min-width: 200px;\n}\n.news-popover-overlay .home-ant-menu-submenu-arrow {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
